// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top
const top100Films = [
  { label: 'The Shawshank Redemption', year: 1994 },
  { label: 'The Godfather', year: 1972 },
  { label: 'The Dark Knight', year: 2008 },
  { label: 'The Godfather Part II', year: 1974 },
  { label: '12 Angry Men', year: 1957 },
  {
    label: 'The Lord of the Rings: The Return of the King',
    year: 2003,
  },
  { label: "Schindler's List", year: 1993 },
  {
    label: 'The Lord of the Rings: The Fellowship of the Ring',
    year: 2001,
  },
  { label: 'Pulp Fiction', year: 1994 },
  { label: 'The Good, the Bad and the Ugly', year: 1966 },
  {
    label: 'The Lord of the Rings: The Two Towers',
    year: 2002,
  },
  { label: 'Forrest Gump', year: 1994 },
  { label: 'Fight Club', year: 1999 },
  { label: 'Inception', year: 2010 },
  {
    label: 'Star Wars: Episode V - The Empire Strikes Back',
    year: 1980,
  },
  { label: 'The Matrix', year: 1999 },
  { label: 'GoodFellas', year: 1990 },
  { label: 'Interstellar', year: 2014 },
  { label: "One Flew Over the Cuckoo's Nest", year: 1975 },
  { label: 'Seven', year: 1995 },
  { label: "It's a Wonderful Life", year: 1946 },
  { label: 'The Silence of the Lambs', year: 1991 },
  { label: 'Seven Samurai', year: 1954 },
  { label: 'Saving Private Ryan', year: 1998 },
  { label: 'The Green Mile', year: 1999 },
  { label: 'City of God', year: 2002 },
  { label: 'Life Is Beautiful', year: 1997 },
  { label: 'Terminator 2: Judgment Day', year: 1991 },
  { label: 'Back to the Future', year: 1985 },
  {
    label: 'Star Wars: Episode IV - A New Hope',
    year: 1977,
  },
  { label: 'Spirited Away', year: 2001 },
  { label: 'The Pianist', year: 2002 },
  { label: 'Gladiator', year: 2000 },
  { label: 'Parasite', year: 2019 },
  { label: 'Kill Bill: The Whole Bloody Affair', year: 2004 },
  { label: 'Grave of the Fireflies', year: 1988 },
  { label: 'Psycho', year: 1960 },
  { label: 'The Lion King', year: 1994 },
  { label: 'Harakiri', year: 1962 },
  { label: 'The Departed', year: 2006 },
  { label: 'Whiplash', year: 2014 },
  { label: 'The Prestige', year: 2006 },
  { label: 'American History X', year: 1998 },
  { label: 'Léon: The Professional', year: 1994 },
  { label: 'Spider-Man: Across the Spider-Verse', year: 2023 },
  { label: 'Cinema Paradiso', year: 1988 },
  { label: 'Casablanca', year: 1942 },
  { label: 'The Intouchables', year: 2011 },
  { label: 'The Usual Suspects', year: 1995 },
  { label: 'Django Unchained', year: 2012 },
  { label: 'Alien', year: 1979 },
  { label: 'Rear Window', year: 1954 },
  { label: 'Modern Times', year: 1936 },
  { label: 'Once Upon a Time in the West', year: 1968 },
  { label: 'City Lights', year: 1931 },
  { label: 'Apocalypse Now', year: 1979 },
  { label: 'WALL·E', year: 2008 },
  { label: 'Memento', year: 2000 },
  { label: 'Dune: Part Two', year: 2024 },
  { label: 'Avengers: Infinity War', year: 2018 },
  { label: 'Raiders of the Lost Ark', year: 1981 },
  { label: 'The Lives of Others', year: 2006 },
  { label: 'Spider-Man: Into the Spider-Verse', year: 2018 },
  { label: 'Sunset Boulevard', year: 1950 },
  { label: 'Witness for the Prosecution', year: 1957 },
  { label: 'Paths of Glory', year: 1957 },
  { label: 'The Shining', year: 1980 },
  { label: 'The Great Dictator', year: 1940 },
  { label: 'Inglourious Basterds', year: 2009 },
  { label: '12th Fail', year: 2023 },
  { label: 'Aliens', year: 1986 },
  { label: 'High and Low', year: 1963 },
  { label: 'Avengers: Endgame', year: 2019 },
  { label: 'Good Will Hunting', year: 1997 },
  { label: 'The Dark Knight Rises', year: 2012 },
  { label: 'Coco', year: 2017 },
  { label: 'Amadeus', year: 1984 },
  { label: 'Toy Story', year: 1995 },
  { label: 'Your Name.', year: 2016 },
  { label: 'Das Boot', year: 1981 },
  { label: 'Braveheart', year: 1995 },
  { label: 'Oldboy', year: 2003 },
  { label: 'Princess Mononoke', year: 1997 },
  {
    label: 'Dr. Strangelove or: How I Learned to Stop Worrying and Love the Bomb',
    year: 1964,
  },
  { label: '3 Idiots', year: 2009 },
  { label: 'American Beauty', year: 1999 },
  { label: 'Capernaum', year: 2018 },
  { label: "Singin' in the Rain", year: 1952 },
  { label: 'Joker', year: 2019 },
  { label: 'Once Upon a Time in America', year: 1984 },
  {
    label: 'Star Wars: Episode VI - Return of the Jedi',
    year: 1983,
  },
  { label: 'Come and See', year: 1985 },
  { label: 'Requiem for a Dream', year: 2000 },
  { label: 'Toy Story 3', year: 2010 },
  { label: 'Project Hail Mary', year: 2026 },
  { label: 'Ikiru', year: 1952 },
  { label: 'The Hunt', year: 2012 },
  { label: 'Incendies', year: 2010 },
  {
    label: 'Eternal Sunshine of the Spotless Mind',
    year: 2004,
  },
  { label: 'The Apartment', year: 1960 },
];

export default top100Films;
